import React, { useContext, useState } from "react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import styles from "./chip.module.scss";
import { checkWhiteIcon, newCheckMark } from "../../../constant";
import { iGlobalContext } from "../../../context/globalContext/interface";
import { StateContext } from "../../../context/globalContext/context";
import BrandIcon from "../brandIcon/BrandIcon";
import { fsPx } from "../../../styles/design-tokens";

export interface ChipProps {
  label: string;
  selected: boolean;
  onSelect: (label: string) => void;
  onBoarding?: boolean;
  showTickIcon?: boolean;
  equalTabsWidth?: boolean;
  // Chip → anchored dropdown affordance: render a down-chevron after the label
  // to hint that the chip opens a dropdown (Google-Flights style). When the
  // caller's dropdown is open, `chevronOpen` rotates the icon 180° to face up.
  // Consumer: filter chips in FlightFilterEntry / HotelFilterEntry DesktopChrome
  // (only when APP_CONFIG.FILTER_DROPDOWN_ACTIVE is true). Default off —
  // existing consumers are unaffected.
  showChevron?: boolean;
  chevronOpen?: boolean;
}

const CustomChip: React.FC<ChipProps> = ({
  label,
  selected,
  onSelect,
  onBoarding = false,
  showTickIcon = true,
  equalTabsWidth = false,
  showChevron = false,
  chevronOpen = false,
}) => {
  const { isMobile }: iGlobalContext = useContext(StateContext);
  const [isHovered, setIsHovered] = useState(false);
  return (
    <>
      {onBoarding ? (
        <button
          className={`${styles.chip1} ${selected ? styles.selected : ""}`}
          onClick={() => onSelect(label)}
          style={equalTabsWidth ? { width: "100%" } : {}}
        >
          {selected && showTickIcon ? (
            <div className={styles.iconCard}>
              <img src={checkWhiteIcon} alt="" className={styles.check} />
            </div>
          ) : null}
          {label}
        </button>
      ) : (
        <button
          style={equalTabsWidth ? { width: "100%" } : {}}
          className={`${styles.chip2} ${selected ? styles.selected : ""}`}
          // A chip that opens a dropdown says whether it is open (the ring chip style
          // also draws the open one as selected).
          aria-expanded={showChevron ? chevronOpen : undefined}
          onClick={() => onSelect(label)}
          onMouseEnter={() => {
            if (!isMobile) setIsHovered(true);
          }}
          onMouseLeave={() => {
            if (!isMobile) setIsHovered(false);
          }}
        >
          {selected && showTickIcon ? (
            <div className={styles.iconCard}>
              {isHovered ? (
                <img src={checkWhiteIcon} alt="" className={styles.check} />
              ) : (
                <BrandIcon src={newCheckMark} className={styles.check} />
              )}
            </div>
          ) : null}
          {label}
          {showChevron ? (
            <KeyboardArrowDownIcon
              style={{
                fontSize: fsPx(18),
                marginLeft: 4,
                transition: "transform 0.2s ease",
                transform: chevronOpen ? "rotate(180deg)" : "rotate(0deg)",
              }}
            />
          ) : null}
        </button>
      )}
    </>
  );
};

export default CustomChip;
